export default __webpack_public_path__ + "static/media/scheduleLogo.82cc1c2e.svg";